import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React from "react";
const RazorpayDetailsTable = ({ razorpaydetails, perpage, currentPage }) => {
  return (
    <>
      <TableBody>
        {razorpaydetails
          .slice((currentPage - 1) * perpage, currentPage * perpage)
          .map((data, index) => (
            <TableRow key={data.id}>
              <TableCell className="text-center text-xs">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data.email}
              </TableCell>
              <TableCell className="text-center text-xs">{data.id}</TableCell>
              <TableCell className="text-center text-xs">
                {data.contact}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data.order_id}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data.entity}
              </TableCell>
              <TableCell>
                <span className="text-center text-xs">{data.amount}</span>
              </TableCell>
              <TableCell>
                <span className="text-center text-sm">{data.currency}</span>
              </TableCell>
              <TableCell
                className={
                  `text-sm px-2 py-1 rounded-md ${
                    data.status === "created"
                      ? "text-blue-500"
                      : data.status === "authorized"
                      ? "text-yellow-500"
                      : data.status === "captured"
                      ? "text-green-500"
                      : data.status === "refunded"
                      ? "text-purple-500"
                      : data.status === "failed"
                      ? "text-red-500"
                      : "text-gray-500"
                  }` // Default color if status is unknown
                }
              >
                {data.status}
              </TableCell>

              <TableCell className="text-center text-sm">
                {data.invoice_id}
              </TableCell>

              <TableCell
                className={
                  `text-sm px-2 py-1 rounded-md ${
                    data.method === "card"
                      ? "text-blue-500"
                      : data.method === "netbanking"
                      ? "text-yellow-500"
                      : data.method === "wallet"
                      ? "text-green-500"
                      : data.method === "emi"
                      ? "text-purple-500"
                      : data.method === "upi"
                      ? "text-red-500"
                      : "text-gray-500"
                  }` // Default color if status is unknown
                }
              >
                {data.method}
              </TableCell>

              <TableCell className="text-center text-sm">
                {data.amount_refunded}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.refund_status}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.captured}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.description}
              </TableCell>
              <TableCell className="text-sm text-center">{data.bank}</TableCell>
              <TableCell className="text-sm text-center">{data.tax}</TableCell>

              <TableCell className="text-sm text-center">
                {new Date(data.created_at * 1000).toLocaleString("en-US", {
                  weekday: "short", // Short weekday (e.g., "Sat")
                  year: "numeric", // Full year
                  month: "short", // Short month (e.g., "Aug")
                  day: "numeric", // Day of the month
                  hour: "2-digit", // Hour in 2-digit format
                  minute: "2-digit", // Minute in 2-digit format
                  hour12: true, // 12-hour format
                })}
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </>
  );
};

export default RazorpayDetailsTable;
